<template>
  <div class="logout">

    <!-- <v-card width="400px" class="mx-auto mt-5">
      <v-card-title>
        <h1 class="display-1">ログアウト</h1>
      </v-card-title>

      <v-card-text>
        <v-card-actions>
          <v-btn
          color="blue"
          class="white--text ml-auto"
          @click="logout">ログアウト</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card> -->

  </div>
</template>

<script>
import { getAuth, signOut } from "firebase/auth";

export default {
  name: 'Logout',

  data: () => ({
    }),

  mounted: function() {
    const auth = getAuth();
      signOut(auth)
      .then(res => {
        this.$router.push({ name: 'Login' })
      })
  },

  // methods: {
  //   logout() {
  //     const auth = getAuth();
  //     signOut(auth)
  //     .then(res => {
  //       this.$router.push({ name: 'Login' })
  //     })
  //   }
  // }
};
</script>
